// noinspection DuplicatedCode

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API

export const getSpecResign = createAsyncThunk(
  "resignTransaksi/getSpecResign",
  async ({ TransaksiApprovalID }, thunkAPI) => {
    let formData = new FormData();
    formData.append("TransaksiApprovalID", TransaksiApprovalID);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getSpecResign",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getResignTransaksi = createAsyncThunk(
  "resignTransaksi/get",
  async ({ start, count, search }, thunkAPI) => {
    let formData = new FormData();
    formData.append("start", start);
    formData.append("count", count);
    formData.append("search", search);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getResign",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const insertResignTransaksi = createAsyncThunk(
  "resignTransaksi/insert",
  async (
    { Nik, TanggalPengajuan, Alasan, AsetPemilikanPerusahaan },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("Nik", Nik);
    formData.append("TanggalPengajuan", TanggalPengajuan);
    formData.append("Alasan", Alasan);
    formData.append("AsetPemilikanPerusahaan", AsetPemilikanPerusahaan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "insertResign",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateResignTransaksi = createAsyncThunk(
  "resignTransaksi/update",
  async (
    { TResignID, Nik, TanggalPengajuan, Alasan, AsetPemilikanPerusahaan },
    thunkAPI
  ) => {
    let formData = new FormData();
    formData.append("TResignID", TResignID);
    formData.append("Nik", Nik);
    formData.append("TanggalPengajuan", TanggalPengajuan);
    formData.append("Alasan", Alasan);
    formData.append("AsetPemilikanPerusahaan", AsetPemilikanPerusahaan);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateResign",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getResignReport = createAsyncThunk(
  "getResignReport/get",
  async (obj, thunkAPI) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "hrd/resign/lap",
        obj,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

//INIT
const initialState = {
  message: "",
  SpecResignData: [],
  isSpecResignFetching: false,
  isSpecResignSuccess: false,
  isSpecResignError: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  errorMessage: "",
};

//SLICES
export const resignTransaksiSlice = createSlice({
  name: "resignTransaksi",
  initialState,
  reducers: {},
  extraReducers: {
    // GET
    [getResignReport.fulfilled]: (state, { payload }) => {
      state.report = payload.data;
      state.isGetReport = true;
      state.message = payload.message;
      return state;
    },
    [getResignReport.rejected]: (state, { payload }) => {
      state.isGetReport = false;
    },
    [getResignReport.pending]: (state) => {
      state.isGetReport = false;
    },
    [getSpecResign.fulfilled]: (state, { payload }) => {
      state.SpecResignData = payload.data[0];
      state.isSpecResignSuccess = true;
      state.message = payload.message;
      return state;
    },
    [getSpecResign.rejected]: (state, { payload }) => {
      state.isSpecResignFetching = false;
    },
    [getSpecResign.pending]: (state) => {
      state.isSpecResignFetching = false;
    },

    [getResignTransaksi.fulfilled]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetSuccess = true;
      state.data = payload.data;
      state.count = payload.count;
      state.message = payload.message;
      return state;
    },
    [getResignTransaksi.rejected]: (state, { payload }) => {
      state.isGetFetching = false;
      state.isGetError = true;
      state.errorMessage = payload.message;
    },
    [getResignTransaksi.pending]: (state) => {
      state.isGetFetching = true;
    },

    // INSERT
    [insertResignTransaksi.fulfilled]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [insertResignTransaksi.rejected]: (state, { payload }) => {
      state.isInsertFetching = false;
      state.isInsertError = true;
      state.errorMessage = payload.message;
    },
    [insertResignTransaksi.pending]: (state) => {
      state.isInsertFetching = true;
    },

    // UPDATE
    [updateResignTransaksi.fulfilled]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateSuccess = true;
      state.message = payload.message;
      window.location.reload(false);
      return state;
    },
    [updateResignTransaksi.rejected]: (state, { payload }) => {
      state.isUpdateFetching = false;
      state.isUpdateError = true;
      state.errorMessage = payload.message;
    },
    [updateResignTransaksi.pending]: (state) => {
      state.isUpdateFetching = true;
    },
  },
});

export const resignTransaksiSelector = (state) => state.resignTransaksi;
